

export const staleWaveformWarningMs = 1000;

export const runBannerAfterScrollMs = 500;

export const valuesColWidth = 100;

export const deleteSymbolWidth = 20;

export const viewSymbolWidth = 20;

export const scrollBarWidth = 15;

export const sheetLoadPollMs = 100;

export const sheetLoadPollTries = 30;

export const leftMargin = 3;

export const rightMargin = 0;

export const waveTableRightGap = scrollBarWidth + 8;

export const topRowButtonMargin = 5;

export const rowHeight = 30;

export const clkLineWidth = 0.8;

export const lineThickness = 0.8;

export const columnFontSize = "12px";

export const columnFontFamily = "Helvetica";

export const valueColumnFontSize = "12px";

export const valueColumnFontFamily = "Helvetica";

export const valueOnWavePadding = 75;

export const valueOnWaveEdgePadding = 4;

export const borderProperties = "2px solid rgb(219,219,219)";

export const labelPadding = 3;

export const namesValuesColumnColor = "Lavender";

export const rowBandColor = "rgba(230,230,250,0.45)";

export const cursorColumnColor = "purple";

export const cursorColumnOpacity = 0.3;

export const softScrollBarWidth = 25;

export const scrollbarThumbMinWidth = 10;

export const topHalfHeight = 260;

export const initSimulationTime = 100;

export const fetchRetryAfterMs = 2000;

export const nonBinaryTransLen = 2;

export const viewBoxHeight = 30;

export const waveHeight = 0.8 * viewBoxHeight;

export const spacing = (viewBoxHeight - waveHeight) / 2;

export const yTop = spacing;

export const yBot = waveHeight + spacing;

export const minVisibleCycles = 3;

export const minCycleWidth = 5;

export const zoomChangeFactor = 1.5;

export const clkCycleNarrowThreshold = 20;

export const extraSimulatedSteps = 5;

export const infoSignUnicode = "🛈";

export const waveLegendMaxChars = 35;

export const valueColumnMaxChars = 35;

export const maxRamRowsDisplayed = 50;

export const maxRamLocsWithSparseDisplay = 100;

export const tooltipTextColour = "black";

export const tooltipBackgroundColor = "#fffdd0";

export const tooltipShadowOpacity = 0.2;

